export default "__VITE_ASSET___1DkY8Mg__";